// extracted by mini-css-extract-plugin
export default {"cell":"CustomTableBody_cell__ZscQT","emptyState--italicText":"CustomTableBody_emptyState--italicText__V+J1- font-sm-regular"};